@if (!store.isSummary) {
    <ap-previous-button (click)="previousQuestion()"></ap-previous-button>
    <div class="bold">{{ 'financial-obligations.payment-account-overdraft.title' | apContent }}</div>
}

@if (showPaymentAccountOverdraftAmount()) {
    <payment-account-overdraft-amount></payment-account-overdraft-amount>
}
@if (showPaymentAccountOverdraftTip()) {
    <payment-account-overdraft-tip></payment-account-overdraft-tip>
}
